import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/folder/styles.scss';export default {
  "folder": "_folder_jrtuc_1",
  "icon": "_icon_jrtuc_35",
  "name": "_name_jrtuc_41",
  "childrenNbr": "_childrenNbr_jrtuc_47",
  "avatar": "_avatar_jrtuc_53",
  "creationDate": "_creationDate_jrtuc_58",
  "contextualMenu": "_contextualMenu_jrtuc_63",
  "removeIcon": "_removeIcon_jrtuc_75",
  "loader": "_loader_jrtuc_79"
};